/**
 * 前端常量配置
 * 集中管理所有硬编码的魔法数字和字符串
 */

// ==================== 分页配置 ====================
export const PAGINATION = {
  DEFAULT_PAGE: 1,
  DEFAULT_SIZE: 20,
  MAX_SIZE: 100,
  SIZE_OPTIONS: [10, 20, 50, 100]
};

// ==================== Socket.io 配置 ====================
export const SOCKET_CONFIG = {
  MAX_RECONNECT_ATTEMPTS: 5,
  RECONNECT_DELAY: 1000,
  PING_TIMEOUT: 60000,
  PING_INTERVAL: 25000
};

// ==================== 防抖延迟配置（毫秒） ====================
export const DEBOUNCE_DELAY = {
  REFRESH: 500,        // 列表刷新防抖
  SEARCH: 300,         // 搜索输入防抖
  RESIZE: 200          // 窗口调整防抖
};

// ==================== 通知相关 ====================
export const NOTIFICATION = {
  DURATION: 5000,      // 消息提示显示时间
  MAX_RECENT: 5,       // 顶部显示最近通知数量
  REFRESH_INTERVAL: 30000 // 轮询间隔（已废弃，保留配置）
};

// ==================== HTTP 状态码 ====================
export const HTTP_STATUS = {
  OK: 200,
  CREATED: 201,
  BAD_REQUEST: 400,
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  TOO_MANY_REQUESTS: 429,
  SERVER_ERROR: 500
};

// ==================== 时间格式化 ====================
export const TIME_FORMAT = {
  DEFAULT: 'YYYY-MM-DD HH:mm:ss',
  DATE: 'YYYY-MM-DD',
  MONTH: 'YYYY-MM',
  TIME: 'HH:mm:ss'
};

// ==================== 常用超时时间（毫秒） ====================
export const TIMEOUT = {
  API: 30000,          // API 请求超时
  UPLOAD: 300000,      // 文件上传超时
  TOAST: 3000          // 提示显示时间
};

// ==================== 角色定义 ====================
export const ROLES = {
  SUPERADMIN: 'superadmin',
  ADMIN: 'admin',
  LEADER: 'leader',
  DELIVERY: 'delivery',
  CUSTOMER: 'customer'
};

// ==================== 订单状态 ====================
export const ORDER_STATUS = {
  PENDING: 'pending',
  PROCESSING: 'processing',
  COMPLETED: 'completed',
  CANCELLED: 'cancelled'
};

// ==================== 本地存储键名 ====================
export const STORAGE_KEYS = {
  TOKEN: 'token',
  USER: 'user',
  PERMISSIONS: 'permissions',
  SETTINGS: 'settings'
};
